import Loadable from '../../components/loadable';

const NetRevenueGraphs = Loadable({
  loader: () => import('../../pages/revenue/net_revenue_graphs'),
  type: 'block',
});

angular.module('gym').value('NetRevenueGraphs', NetRevenueGraphs);
